export default {
  agency: 'Agentur Nummer',
  slaughterHouse: 'Schlachthof',
  slaughterHouses: 'Schlachthöfe',
  lfbisInput: "LFBIS muss 7 stellig sein",
  specificData: 'Schlachthof spezifische Daten',
  carrier: "LFBIS Frächter",
  zsdb: "LFBIS ZSDB",
  selectModal: "Schlachthof wählen",
  transport: {
    self: 'Selbst Ein',
    transporter: 'LKW Ein',
    classification: 'Selbst Klass',
  },
  notification: {
    save: {
      type: 'success',
      message: 'Schlachthof Infos erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    }
  }
}
